import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError, concatMap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from 'src/@vex/services/navigation.service';
import { DemoDialogComponent } from './pages/ui/components/components-overview/components/components-overview-dialogs/components-overview-dialogs.component';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private dialog: MatDialog) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   return next.handle(req).pipe(catchError(x=> this.handleAuthError(x))); 
   }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401 || err.status === 403) {
        this.dialog.open(DemoDialogComponent,{
          width: "260px"
        })
    }else{
     
    }
    return throwError(err);
}
}
